import { render, staticRenderFns } from "./JSONBuilder.vue?vue&type=template&id=3094eec5&scoped=true&"
import script from "./JSONBuilder.vue?vue&type=script&lang=js&"
export * from "./JSONBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3094eec5",
  null
  
)

export default component.exports